import type { Client, RequestContext } from "../client";
import type { CreateSupportRequestCommand, CreateSupportRequestResponse } from "../resources/supportRequestResource";
export class SupportRepository {
    constructor(private client: Client, private requestContext: RequestContext) { }
    async createSupportRequest(command: CreateSupportRequestCommand): Promise<CreateSupportRequestResponse> {
        return this.client.post<CreateSupportRequestResponse>(this.requestContext, "~/api/supportrequest", command);
    }
}
